// extracted by mini-css-extract-plugin
module.exports = {"pink100":"#F9D8CB","blue100":"#E2EBFF","errorBg":"#FFE7E9","container":"ErrorMessage_container__diNug","message":"ErrorMessage_message__fUVW_"};